import { LicenseInfo as MuiXLicenseInfo } from '@mui/x-license-pro';

const MUI_X_LICENSE_KEY =
  '68dcb983cd4ae7a795710862f41193f1Tz0xMTc2MjcsRT0xNzg2NjY1NTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=';

if (MUI_X_LICENSE_KEY) MuiXLicenseInfo.setLicenseKey(MUI_X_LICENSE_KEY);

export const MuiXLicense = () => {
  return null;
};
